import theme from '@/config/theme';
import store from '@/store';
export default function (num) {    
    const themeStyle = num >= theme.length ? theme[0] : theme[num];
    const { color } = store.state.layout.setting;
    const themeDom = document.createElement('style');
    themeDom.className = 'layout-side-setting';    
    themeDom.innerText = `
    :root {
        --color-primary: ${color.primary} !important;
    }
    .layout-sidebar-logo {
        background-color: ${themeStyle.logoBg || themeStyle.sidebarBg} !important;
        color: ${themeStyle.logoColor || themeStyle.sidebarColor} !important;
    }
    .layout-sidebar {
        background-color: ${themeStyle.sidebarBg} !important;
    }
    .layout-sidebar .el-menu {
        background-color: ${themeStyle.sidebarBg} !important;
        border-right: 0;
    }
    .layout-sidebar .el-menu .el-menu {
        background-color: ${themeStyle.sidebarChildrenBg} !important;
    }
    .layout-sidebar .el-submenu__title {
        color: ${themeStyle.sidebarColor} !important;
    }
    .layout-sidebar .el-menu-item {
        color: ${themeStyle.sidebarColor} !important;
    }
    .layout-sidebar .el-menu-item:focus,
    .layout-sidebar .el-menu-item:hover,
    .layout-sidebar .el-submenu__title:hover {
        background-color: transparent !important;
        color: ${themeStyle.sidebarActiveColor} !important;
    }
    .layout-sidebar .el-menu-item-group__title {
        padding: 0;
    }
    .layout-sidebar .el-submenu.is-active > .el-submenu__title,
    .layout-sidebar .el-submenu.is-active > .el-submenu__title > i {
        color: ${themeStyle.sidebarActiveColor} !important;
    }
    .layout-sidebar .el-menu-item.is-active {
        background-color: ${themeStyle.sidebarActiveBg} !important;
        color: ${themeStyle.sidebarActiveColor} !important;
        border-right: 3px solid ${themeStyle.sidebarActiveBorderRightBG};
    }
    ${(function () {
        let s = '';
        if (themeStyle.navbarBg) {
            s += `.layout-main-navbar {
                background-color: ${themeStyle.navbarBg} !important;
            }`;
        }
        if (themeStyle.navbarColor) {
            s += `.layout-main-navbar {
                color: ${themeStyle.navbarColor} !important;
            }
            .layout-main-navbar .el-breadcrumb .el-breadcrumb__inner,
            .layout-main-navbar .el-breadcrumb .el-breadcrumb__separator,
            .layout-main-navbar .el-breadcrumb .el-breadcrumb__inner:hover,
            .layout-main-navbar .el-breadcrumb .el-breadcrumb__separator:hover,
            .layout-main-navbar .el-dropdown {
                color: ${themeStyle.navbarColor} !important;
            }`;
        }
        if (themeStyle.tagsBg) {
            s += `.layout-main-tags {
                background-color: ${themeStyle.tagsBg} !important;
            }`;
        }
        if (themeStyle.tagsColor) {
            s += `.layout-main-tags {
                color: ${themeStyle.tagsColor} !important;
            }`;
        }
        return s;
    })()}
    .layout-main-content {
        background-color: ${themeStyle.mainBg} !important;
    }
    .layout-tags-active {
        background-color: ${themeStyle.tagsActiveBg} !important;
        color: ${themeStyle.tagsActiveColor} !important;
    }
    .layout-sidebar-sidesetting > i {
        background-color: ${themeStyle.sidebarActiveBg} !important;
        color: ${themeStyle.sidebarColor} !important;
    }
    `.replace(/\n/g, '').replace(/ {4}/g, '');
    const prevTheme = document.querySelector('style.layout-side-setting');
    prevTheme && prevTheme.remove();
    document.head.appendChild(themeDom);
    return themeDom;
}